module.exports = __webpack_public_path__ + "img/new-greeting.9b2b759b.svg";